import React from 'react';
import {Text, TextPriority} from '@wix/wix-ui-tpa/cssVars';
import {classes} from './Summary.st.css';
import {PaymentRequestTotals, PaymentRequestTotalsDataHooks} from './PaymentRequestTotals/PaymentRequestTotals';
import {PaymentRequestItemSection} from './PaymentRequestItemSection/PaymentRequestItemSection';
import {useControllerProps} from '../Widget/ControllerContext';
import {PaymentRequestMobileSummary} from './PaymentRequestMobileSummary';
import {useLocaleKeys} from '../../../locale-keys/LocaleKeys';

export enum SummaryDataHooks {
  root = 'SummaryDataHooks.root',
}

export interface SummaryProps {
  dataHook: string;
}

export const Summary = ({dataHook}: SummaryProps) => {
  const {
    isOneColumnView,
    paymentRequestStore: {paymentRequest},
  } = useControllerProps();

  const localeKeys = useLocaleKeys();

  return (
    <div className={isOneColumnView ? classes.sticky : classes.root} data-hook={dataHook}>
      {isOneColumnView ? (
        <PaymentRequestMobileSummary total={paymentRequest.total.formattedAmount} />
      ) : (
        <div data-hook={SummaryDataHooks.root} className={classes.summary}>
          <Text
            tagName={'h2'}
            priority={TextPriority.primary}
            className={classes.overviewTitleText}
            data-hook={PaymentRequestTotalsDataHooks.OverviewTitle}>
            {localeKeys.checkout.paylink.totals.title()}
          </Text>
          <PaymentRequestItemSection />
          <PaymentRequestTotals total={paymentRequest.total.formattedAmount} />
        </div>
      )}
    </div>
  );
};
